import React, { Component } from 'react'
import FileInputUI from './FileInputUI.js'

class FileInputSF extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = React.createRef();
  }

  render() {
    return (
      <FileInputUI
        fileInput={this.fileInput}
        handleSubmit={this.handleSubmit} />
    )
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log(`Selected file - ${this.fileInput.current.files[0].name}`)
    this.props.onClick(this.fileInput.current.files[0])
  }
}

export default FileInputSF
